import React from 'react';
import DfbIcon from '../ui-kit/dfb_icon';
import cloudinary from 'cloudinary-core';

const CLightbox = (props) => {
  const cl = new cloudinary.Cloudinary({cloud_name: process.env.CLOUDINARY_CLOUD_NAME, secure: true});
  const lightboxImgUrl = cl.url(
    props.image.src,
    {
      type: 'fetch',
      crop: 'fit',
      width: props.width,
      height: props.height,
      quality: 'auto',
      fetchFormat: 'auto'
    }
  )

  return (
    <div className="c-Lightbox">
      <div className="dfb-Modal dfb-Modal--fullsize c-Lightbox-modal" role="dialog" aria-hidden="true" tabIndex="-1" data-modal id={props.id}>
        <div className="dfb-Modal-surface">
          <div className="dfb-Modal-container">
            <div className="dfb-Modal-content" role="document" tabIndex="-1">
              <div className="dfb-Modal-contentContainer">
                <button type="button" className="dfb-Modal-dismissButton" data-dismiss="modal">
                  <DfbIcon icon_type="close" />
                </button>
                <div className="c-Lightbox-wrapper">
                  <div className="c-Lightbox-content">
                    <div className="c-Lightbox-imageContainer" data-src={lightboxImgUrl} data-alt={props.image.alternative}>
                      <button className="dfb-IconButton c-Lightbox-zoomToggleButton" type="button">
                        <span className="dfb-Icon dfb-IconButton-icon">
                          <DfbIcon icon_type="enlarge" />
                        </span>
                        <span className="dfb-IconButton-label">Bild zoomen</span>
                      </button>
                      <div className="dfb-Spinner dfb-Spinner--continuous u-Theme-dark c-Lightbox-spinner" role="progressbar">
                        <div className="dfb-Spinner-value">0</div>
                      </div>
                    </div>
                    <div className="c-Lightbox-caption">
                      <p className="dfb-Paragraph u-Theme-dark">
                        {props.image.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CLightbox;